export default "__VITE_ASSET__B8X$8xsM__"